import { createContext, useContext } from 'react';

import { IPermissionCheck } from '~/src/dash/utils/permission_service';
import { ILineItemsListViewConfig } from '~/src/dash/views/campaigns/line-items/LineItemsListView/config';

interface ILineItemsListContext {
  cfg: ILineItemsListViewConfig;
  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
}

export const OrderLineItemsListContext = createContext({} as ILineItemsListContext);
export const useLineItemsListStore = (): ILineItemsListContext =>
  useContext(OrderLineItemsListContext);
